<script lang="ts">
import "@cisco-u/tooltip/cu-tooltip.js";
import "@cisco-u/icons/icons/cu-icon-info.js";
import "@cisco-u/link/cu-link.js";

import { defineComponent } from "vue";

import isUnauth from "@/utils/isUnauth";
import telemetry from "@/utils/telemetry";

export default defineComponent({
  data() {
    return {
      blueIcon: false,
      showTooltip: false,
      url: "https://www.cisco.com/c/en/us/training-events/training-certifications/training-catalog.html?delivery_options=instructor_led",
    };
  },
  methods: {
    isUnauth,
    async sendTelem() {
      await telemetry.click_on_cta(
        this.$route.path,
        "Training Catalog",
        this.isUnauth(),
        "link"
      );
      window.open(this.url, "_blank", "noopener");
    },
  },
});
</script>

<template>
  <div class="ilt-md relative hidden justify-center md:block">
    <div
      class="inline-block"
      @mouseenter.prevent="blueIcon = true"
      @mouseleave.prevent="blueIcon = false"
      @focusin="blueIcon = true"
      @focusout="blueIcon = false"
    >
      <slot></slot>
    </div>

    <div class="ml-2 inline-flex items-center">
      <cu-tooltip position="top" class="text-blue">
        <cu-icon-info size="l" slot="parent"></cu-icon-info>
        View all instructor-led training at the
        <cu-link
          href="https://www.cisco.com/c/en/us/training-events/training-certifications/training/training-services/courses.html"
          target="_blank"
          dark=""
          >Training Catalog</cu-link
        >.
      </cu-tooltip>
    </div>
  </div>
</template>

<style scoped>
.tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 9%;
  transform: translateX(-100%);
  width: 0;
  height: 0;
  border-left: 0.375rem solid transparent;
  border-right: 0.375rem solid transparent;
  border-top: 0.375rem solid #0d0d0e;
}
</style>
